// @ts-ignore
import styles from './SelectBox.css';

import * as React from "react";
import {SelectBoxProps} from "../Definitions";

export const SelectBox = (props: SelectBoxProps) => {
    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const value = event.target.value;
        props.onChange(value, props.name);
    }

    return (
        <div className={styles.selectContainer}>
            <select
                name={props.name}
                className={styles.filterSelect}
                value={props.initialValue}
                onChange={handleChange}
            >
                {
                    (props.emptyValue)
                        ? <option value="">
                            {props.emptyValue}
                        </option>
                        : null
                }
                {
                    props.options &&
                        Object.entries(props.options).map(([id, value]) => (
                            <option
                                key={id}
                                value={id}
                            >
                                {value}
                            </option>
                        ))
                }
            </select>
        </div>
    )
}
